<!-- OpenByHour2.vue -->
<template>
<div class="debugOutline2">

    <v-card class="mt-1 pl-1 pr-1">
        <v-layout class="tSmall ml-4 pt-2">
            <v-flex xs6
                class="align-content-center light-blue--text text--lighten-4 tSmaller pt-0"
                >
                Select Date to Review

<!-- OpenByHour2.vue 


     </v-flex>
            <v-flex xs6
                class="align-content-center light-blue--text text--lighten-4 tSmaller pt-0"
                >

-->


       
<v-btn 
x-small
                @click="selectedIndex=''" 

selectedIndex
>
Clear
</v-btn>

            </v-flex>



        </v-layout>
        <v-layout class="tSmall ml-4">
            <v-flex xs1>
            </v-flex>
            <v-radio-group v-model="selectedIndex" row >
                <div
                    v-for="(d, index) in $store.state.sniffing.teeSheetDates2" 
                    :key=index
                    class="dSelect"
                    >
                    <v-flex xs1>
                        <v-radio>
                            <template v-slot:label>
                                <span class="primary--text tSmall">{{ shortDate(d) }} </span>
                            </template>
                        </v-radio>
                    </v-flex>
                </div>
            </v-radio-group>
        </v-layout>
    </v-card>



{{ this.$store.state.selectIndex }}


    <v-card class="mt-1 pl-1 pr-1">
        <v-card-title>
            T-Times Open:  
            <!-- {{teeSheetDate}} -->
            {{  shortenDate( $store.state.sniffing.teeSheetDates[selectedIndex] ) }} 
            <span class='tRed' v-if="$store.state.teeSheets[selectedNode]===undefined"> ... NOT POSTED YET</span>
        </v-card-title>

        <v-layout>
            <v-flex xs2 class="tR"
            ></v-flex>

            <v-flex xs1 
                v-for="(h, index) in hours" 
                :key=index
                class="ml-0 pr-0 tC"
                >
                {{ h }} 

            </v-flex>
        </v-layout>

        <div 
            v-for="(c, indx0) in courses" 
                :key=indx0
                class="tC "
                >

                <v-layout
                    v-if="$store.state.sniffing!=undefined"
                        wrap
                        class="pt-0 ml-0 mr-0 pr-0 tRed tBold"
                        >
                                                            
                    <v-flex xs2>
                        <!-- format for narrow devices -->
                        <span class="tC"
                        v-if="$vuetify.breakpoint.xsOnly"
                        v-bind:class="classObject2(c,'narrow')"             
                        >{{c.substring(0,2)}}</span>
                        <!-- format for wider devices -->
                        <span class="tC"
                        v-else
                        v-bind:class="classObject2(c)"             
                        >{{c}}</span>
                    </v-flex>

                    <!-- populate the cell with the number of tee openings for the course and hour -->
                    <v-flex xs1 
                        class="ml-0 pr-0 tC tHour"
                        v-for="(h1, indx1) in hours" 
                            :key=indx1
                            >
                            {{ blankIfUndefined(openByHour[c], h1 ) }}
                    </v-flex>
                </v-layout>
        </div>
        <!-- $store.getters.selectedDate2 = {{ sd2 }} {{ this.$store.getters.selectedDate2 }} -->

    </v-card>

</div>
</template>

<script>

// includes chelseaDateToYYYY_MM_DD()
import { exampleMixin } from '../mixins/exampleMixin.js'   // eslint-disable-line no-unused-vars

export default {

    mixins: [exampleMixin],

    data() {
        return {

            items: [],
            selectedIndex: '',
            selectedNode: "",

            courses: ["Cimarron","Desert","North","South"],

            //hours: ["07","08","09","10","11","12","01","02","03","04","05"],
            // can't fit more than 10 in the flex grid system
            hours: ["08","09","10","11","12","01","02","03","04","05"],

            openByHour: {
                "Cimarron" : {
                    "03" : 10,
                    "08" : 19
                },
                "Desert" : {
                    "02" : 1,
                    "04" : 8,
                    "08" : 1
                },
                "North" : {
                    "08" : 17
                },
                "South" : {
                    "04" : 7
                }
            },
        }
    },

    props: {
        teeSheetDate: String,
    },

    watch: {
    
        selectedDate2: function () {

                console.log("openByHour", this.openByHour)
            //this.selectedNode = "teeSheets/d"+ this.selectedDate2
            this.selectedNode = "d"+ this.selectedDate2
                console.log("selectedNode", this.selectedNode)
                console.log("state selectedNode", this.$store.state[this.selectedNode])
            if (this.$store.state.teeSheets[this.selectedNode] != undefined ) {
                this.openByHour = this.$store.state.teeSheets[this.selectedNode].openByHour
            }
            else {
                this.openByHour = {}            
            }
        },

        selectedIndex: function () {
            // 0 to 5 based on what was clicked
            console.log("selectedIndex = ",this.selectedIndex)
            //alert(this.selectedIndex)
            this.$store.dispatch( 'setSelectedIndex', {"stateName":"selectIndex","value":this.selectedIndex} )
        }

    },

    computed: {

        sd2 () {
            return this.$store.getters.selectedDate2
        },

        selectedDate2 () {
            return this.$store.state.sniffing.teeSheetDates2[this.selectedIndex]
        },
    },

    methods: {

        shortenDate (d) {
            if (d===undefined) return ""
            // February 11, 2020 - Tuesday   ==> Feb 11 - Tue
            const i = d.indexOf(" ")
            const j = d.indexOf("-")

            let s = ""
            s += d.substring(0,3)+d.substring(i,i+3)
            s += d.substring(j-1,j+5)
            return s
        },



        blankIfUndefined(obj,prop) {
            if (obj===undefined) return ""
            if (obj[prop]===undefined) return ""
            return obj[prop]
        },

        shortDate(date8) {
            if (date8===undefined) return ""
            const mon = ["","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
            const m = Number(date8.substring(4,6))
            const d = Number(date8.substring(6,8))
            return mon[m]+"."+String(d)
        },

                            /*
                            XXXtotalsByCourse () {
                                let t = {}
                                for (let c in this.courses) {
                                    let cc = this.courses[c]
                                            //  console.log(`${property}: ${object[property]}`);
                                    t[cc] = 0;
                                    for (let h in this.holes) {
                                        if (this.openByHours[cc]!=undefined) {
                                            if (this.openByHours[cc][h]!=undefined) {
                                                t[cc] = t[cc] + Number( this.openByHours[cc][h] )
                                                    console.log("totalsByCourse",cc,h,t[cc])
                                            }
                                        }
                                    }
                                }
                                return t
                            },


                            XtotalsByAll(openByHour) {
                                let t = 0;
                                let cc = "";
                                let hh = "";
                                            console.log("totalsByAll openByHour",openByHour)

                                for (let c in this.courses) {
                                    //  console.log(`${property}: ${object[property]}`);
                                        cc = this.courses[c];
                                            console.log("totalsByAll c",c,cc)

                                    for (let h in this.holes) {
                                            console.log("totalsByAll c h",this.courses[c],this.holes[h],hh)
                                        if (this.openByHour[c][h] != undefined) t = t + Number(openByHour[c][h])
                                        //t = t + Number( this.openByHours[c][h] )
                                    }
                                }
                                return t
                            },
                            */

      getCorrectString (dateTimeString) {
          var a  = new Date(dateTimeString);
          return ('00'+(a.getMonth()+1)).substring(('00'+(a.getMonth()+1)).length-2) +'/'
              +('00'+a.getDate()).substring(('00'+a.getDate()).length-2)+' '
              +a.getFullYear()+' '
              +('00'+a.getHours()).substring(('00'+a.getHours()).length-2)+':'
              +('00'+a.getMinutes()).substring(('00'+a.getMinutes()).length-2)+':'
              +('00'+a.getSeconds()).substring(('00'+a.getSeconds()).length-2);
      },

      classObject2: function (course,w) {
            //console.log("classObject",course)
        let s = "tCourse "
        // classes for narrow course names (small devices)
        if (w==="narrow") {
            if(course=="South") s += ' sSouth' 
            if(course=="North") s += ' sNorth' 
            if(course=="Desert") s += ' sDesert' 
            if(course=="Cimarron") s += ' sCimarron' 
        }
        // classes for full course names (larger devices)
        else {
            if(course=="South") s += ' cSouth' 
            if(course=="North") s += ' cNorth' 
            if(course=="Desert") s += ' cDesert' 
            if(course=="Cimarron") s += ' cCimarron' 
        }
        return s
      },
/*
      clearSelectIndex () {

        this.$store.state.selectIndex = -1

      },
*/



  }

}

</script>

<style scoped>

    .dSelect {
        border: 1px solid lightgrey;
        padding: 3px 10px 1px 10px;
    }
    .dWhite {
        color: white;
    }

    /* styles for the various courses */
    .tCourse {
        color: white;
        width: 100%;
        margin-bottom: 13px;
        align: right;
    }
    .tHour {
        border: 1px solid lightgrey;
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 115% !important;  
        height: 27px;
    }

    /* these are for longer course names for larger devices */
    .cNorth {
        background-color: green;
        padding: 4px 22px 5px 22px;
    }
    .cSouth {
        background-color: yellowgreen;
        padding: 4px 21px 5px 22px;
    }
    .cDesert {
        background-color: goldenrod;
        padding: 4px 18px 5px 18px;
        margin-top: 5px;
    }
    .cCimarron {
        background-color: dodgerblue;
        padding: 4px 8px 5px 8px;
    }
    /* these are for shortened course names for smaller devices */
    .sNorth {
        background-color: green;
        padding: 4px 9px 5px 9px;
    }
    .sSouth {
        background-color: yellowgreen;
        padding: 4px 10px 5px 10px;
    }
    .sDesert {
        background-color: goldenrod;
        padding: 4px 9px 5px 9px;
        margin-top: 5px;
    }
    .sCimarron {
        background-color: dodgerblue;
        padding: 4px 10px 5px 10px;
    }

</style>